import { routesMap } from '../../routes/AppRoutes';
import HeroSection from '../conduct-risk/HeroSection';

const BannerBanksPage = () => {
  return (
    <HeroSection
      title="Lista Banche"
      description="In questa sezione puoi gestire e configurare le banche disponibili nel sistema."
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: '#', title: 'Banche e fonti dati' },
      ]}
    />
  );
};

export default BannerBanksPage;
